import { Star } from "lucide-react";

export default function StarRating({ rating = 0, onChange, size = "w-5 h-5", interactive = false }) {
  return (
    <div className="flex items-center gap-0.5" data-testid="star-rating">
      {[1, 2, 3, 4, 5].map((star) => (
        <button
          key={star}
          type="button"
          disabled={!interactive}
          onClick={() => interactive && onChange?.(star)}
          className={interactive ? "cursor-pointer hover:scale-110 transition-transform" : "cursor-default"}
          data-testid={`star-${star}`}
        >
          <Star
            className={`${size} ${star <= rating ? "fill-[#FACC15] text-[#FACC15]" : "fill-none text-[#CBD5E1]"}`}
          />
        </button>
      ))}
    </div>
  );
}
